import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'ExclusivesListAlert',

  props: {
    alertText: {
      type: String as PropType<string>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
};
